<template>
  <div id="poster_themeList">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="!isShowAnalysisFlag && renderThemeList"
    />
    <div
      class="themeItem_container"
      v-for="item in renderThemeList"
      :key="item.analysisItemId"
      :class="
        width100ThemeGraphicsIds.includes(item.graphicsId)
          ? width100ThemeGraphicsIdsClassName[
              width100ThemeGraphicsIds.indexOf(item.graphicsId)
            ]
          : ''
      "
    >
      <selectThemeContainer
        v-if="cssDynamicObj"
        :currThemeObj="currThemeObj"
        :themeItem="item"
        :width100ThemeGraphicsIds="width100ThemeGraphicsIds"
        :width100ThemeGraphicsIdsClassName="width100ThemeGraphicsIdsClassName"
        @changeSelectToThemeItemEvent="changeSelectToThemeItem"
        @inFilterChangeEvent="changeSelectToThemeItemHandler"
        :cssDynamicObj="cssDynamicObj"
        viewType="poster"
      ></selectThemeContainer>
    </div>
  </div>
</template>

<script>
/*
 * @Author: wzc
 * @Date: 2024-04-17
 * @LastEditors: wzc
 * 展示在【数据海报-编辑用工作站】中，目前只需要展示一个主题
 * 与类似赛果多个主题列表 且主题带选择框 组件dom一致，区别在于方法和函数要少很多
 * @LastEditTime: 2023-04-17
 * 备注：主要应于 类似于赛果中的【数据分析】主题list；多个主题
 * 【足球世界杯：赛果（未同步）】
 * 【综合性赛事：赛果|小项数据分析】
 * 【CBA：赛果（未同步）】
 * 【羽毛球：赛果|晋级之路】
 */
// 该组件主要对应 more_findAnalysisItem_data.js 文件
import formAnalysisIDToRenderThemeList_data_mixin from '@mixins/formAnalysisIDToRenderThemeList_data'
import dataPoster_base_data_mixin from '@mixins/dataPoster_base_data'
import selectThemeContainer from '@components/platfromBase/compreSportsMeet/selectThemeContainer.vue'
import NOT_DATA from '@components/base/NO_DATA.vue'
export default {
  name: 'poster_themeList',
  mixins: [
    dataPoster_base_data_mixin,
    formAnalysisIDToRenderThemeList_data_mixin,
  ],
  components: {
    NOT_DATA,
    selectThemeContainer,
  },
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    findAnalysisItemResData: {
      type: Array,
      default: () => {
        return []
      },
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    findAnalysisItemParams: {
      // more_findAnalysisItem_data_mixin 里面直接取这个值用，获取主题分析项时用到的参数，并且在主题中获取数据|主题上面的选择下拉框中用的参数都这个值里面的
      type: Object,
      default: () => {
        // return {
        //   sportType: 'compreSportsMeet',
        //   templateType: this.themeTemplateType,
        //   cid: this.currCid,
        //   sid: this.currSid,
        //   did: 0,
        //   eid: 0,
        //   pid: 0,
        //   mid: this.mid,
        // }
        return {}
      },
    },
    paramsChangeObj: {
      // 这个根据当前页面逻辑，可用可不用，这个是当主题参数改变是重新刷新数据，跟定时更新数据不一样
      type: Object,
      default: () => {
        return {
          type: '',
          num: 0,
        }
      },
    },
  },
  data() {
    return {
      paramsChangeType: '', // ['reset'(主题个数不变，但是主题的数据要变，变数据时主题不会消失), 'clear'(主题的个数可能会变，renderThemeList=null，相当于重新初始化组件，变数据时主题会消失)]
      width100ThemeGraphicsIds: [4004],
      width100ThemeGraphicsIdsClassName: [
        'width100', //4004(羽毛球【汤尤杯】运动员对阵)
      ],
      cssDynamicObj: null,
      pageView: 'posterData',
    }
  },
  created() {
    this.init()
  },
  watch: {
    paramsChangeObj: {
      handler(newVal, oldVal) {
        console.debug('主题参数改变，重新加载数据:', newVal, oldVal)
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.paramsChangeType = newVal.type
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
    renderThemeList: {
      handler(newVal, oldVal) {
        console.debug('主题参数改变，重新加载数据:', newVal, oldVal)
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          if (!this.cssDynamicObj) {
            this.$nextTick(() => {
              const themeContainerDomList = document.querySelectorAll(
                '.themeItem_container'
              )
              console.debug(
                'themeContainerDomList:',
                themeContainerDomList[0].offsetWidth
              )
              // this.cssDynamicObj = this.getMixvw(
              //   themeContainerDomList[0].offsetWidth * 1.642
              // )
              this.cssDynamicObj = {
                mixvw: 0.61,
              }
              // 基础是1000
              // 0.24/0.394 = 0.609
            })
          }
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      this.getMoreThemeDatas()
    },
    getMoreThemeDatas() {
      if (this.findAnalysisItemResData) {
        // 走获取主题流程逻辑
        if (this.paramsChangeType === 'clear') {
          this.renderThemeList = null
        }
        // resDataArr = [themeList, themeAnalysisItemIdArr, jsonArr]
        const resDataArr = this.findAnalysisItemResDataToThemeListHandler(
          this.findAnalysisItemResData
        )
        console.debug('resDataArr:', resDataArr)
        // this.$emit('themeItemRenderDataEvent', {
        //   themeItem:
        //     resDataArr[0] && resDataArr[0][0] ? resDataArr[0][0] : null,
        // })
        this.themeList = resDataArr[0]
        this.themeAnalysisItemIdArr = resDataArr[1]
        this.jsonArr = resDataArr[2]
        this.refreshCallback() //根据参数，获取最新主题数据
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#poster_themeList {
  /* padding: 1.388vw 0; */
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .themeItem_container {
    width: 100%;
    &.width100 {
      width: 100%;
    }
  }
}

</style>
